import { Origin } from "@/domain/entities/Origin";
import { IChangeOriginStatusProtocol, IChangeOriginStatusProtocolRequest, IChangeOriginStatusProtocolResponse } from "../../protocols/origin/IChangeOriginStatusProtocol";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";

export class ChangeOriginStatusUseCase implements IChangeOriginStatusProtocol {
  constructor(private originsRepository: IOriginsRepository){}
  async execute({originId}: IChangeOriginStatusProtocolRequest): Promise<IChangeOriginStatusProtocolResponse> {
    const origin = await this.originsRepository.findById(originId)

    if(!origin){
      throw new Error('Origin does not exists.')
    }

    origin.changeStatus()
    
    await this.originsRepository.save(origin)

    return {
      origin
    }
  }
}